import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { PeekGrid } from "@piiqtechnologies/ui-components";
import { RefetchProvider, useAnalytics } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import AppHeader from "@components/app-header";
import { USER_ROLES } from "@constants/Roles";
export const HomeLayout = () => {
    var _a, _b;
    const analytics = useAnalytics();
    const { user } = useAuthContext();
    useEffect(() => {
        var _a;
        analytics.page({
            title: `Peek Dashboard || Home || ${((_a = user === null || user === void 0 ? void 0 : user.organization) === null || _a === void 0 ? void 0 : _a.name) || (user === null || user === void 0 ? void 0 : user.name)}`,
        });
    }, []);
    return (React.createElement(PeekGrid, { container: true },
        user.roleId && user.roleId !== USER_ROLES.Owner && (React.createElement(PeekGrid, { item: true, xs: 12, py: 4 },
            React.createElement(AppHeader, { headerLabel: (_b = (_a = user === null || user === void 0 ? void 0 : user.organizations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, null)))));
};
export default HomeLayout;
